// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorsfulldiv
{
    width: 100%;
    height: 100%;
    background-color: transparent;

}

.errorstitle
{
    width: 96%;
    color: black;
    margin-left: 2%;
    margin-top: 2%;
    margin-bottom: 7px;
    border-radius: 5px;
    height: 20px;
    font-size: 13px;
    background-color: var(--default-icon-color);
}

.errorstoolsbar
{
    width: 100%;
    height: 28px;
    background-color: transparent;
}

.errorsbody
{
    width: 100%;
    height: calc(94% - 28px - 27px);
    background-color: transparent;
    border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/subtitleerrors/subtitleerrors.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,YAAY;IACZ,6BAA6B;;AAEjC;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,2CAA2C;AAC/C;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,+BAA+B;IAC/B,6BAA6B;IAC7B,kBAAkB;AACtB","sourcesContent":[".errorsfulldiv\n{\n    width: 100%;\n    height: 100%;\n    background-color: transparent;\n\n}\n\n.errorstitle\n{\n    width: 96%;\n    color: black;\n    margin-left: 2%;\n    margin-top: 2%;\n    margin-bottom: 7px;\n    border-radius: 5px;\n    height: 20px;\n    font-size: 13px;\n    background-color: var(--default-icon-color);\n}\n\n.errorstoolsbar\n{\n    width: 100%;\n    height: 28px;\n    background-color: transparent;\n}\n\n.errorsbody\n{\n    width: 100%;\n    height: calc(94% - 28px - 27px);\n    background-color: transparent;\n    border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
